import { useProcess } from "@/global-data";
import { createPortal } from "react-dom";
export const ProcessLoader = () => {
  const { process } = useProcess();

  return process
    ? createPortal(
        <div className="bg-white/50 fixed top-0 left-0 w-full h-full z-[999] flex justify-center items-center">
          <div className="loader"></div>
        </div>,
        document.body
      )
    : null;
};
